import { createSiteClient, resolveSiteSlug } from "@lumora/ui";

export const SITE = resolveSiteSlug("turnstill");

/** Persists owner/staff JWTs across reloads (Connect+). Harmless on Spark/Brand. */
export const client = createSiteClient(SITE);
